import styled from 'styled-components'

const MainContainer = styled.main`
  display: flex;
  width: ${props => (props.push ? 'calc(100% - 340px)' : '100%')};
  ${props => props.push && 'margin-left: 340px;'};
`

export default MainContainer
